import * as React from 'react';
import { useEffect } from 'react';
import api from "../../utils/api";
import * as util from "../../utils/util";
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import icon_inspection1 from "../../assets/images/icon_inspection1_2.png";
import icon_inspection2 from "../../assets/images/icon_inspection2_2.png";
import icon_inspection3 from "../../assets/images/icon_inspection3_2.png";
import icon_inspection4 from "../../assets/images/icon_inspection4_2.png";
import icon_inspection5 from "../../assets/images/icon_inspection5_2.png";
import icon_inspection6 from "../../assets/images/icon_inspection6_2.png";
import icon_inspection7 from "../../assets/images/icon_inspection7_2.png";
import icon_inspection8 from "../../assets/images/icon_inspection8_2.png";
import icon_inspection9 from "../../assets/images/icon_inspection9_2.png";
import icon_inspection10 from "../../assets/images/icon_inspection10_2.png";
import icon_inspection11 from "../../assets/images/icon_inspection11_2.png";
import icon_inspection12 from "../../assets/images/icon_inspection12_2.png";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import HealthResultItem from "./HealthResultItem";
import HealthResultTotal from "./HealthResultTotal";
import HealthResultCompare from "./HealthResultCompare";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';

const HealthResult = () => {
  const navigate = useNavigate();
  const [resultData, setResultData] = React.useState([]);
  const [ownerFamID, setOwnerFamID] = React.useState('');
  // 이름 초기값은 로그인 시 저장해 둔 localStorage.userName (MoreInfo 와 같은 이유 —
  // 무조건 '비회원'으로 시작하면 조회가 끝날 때까지 로그인 사용자도 '비회원'으로 보인다)
  const [memberName, setMemberName] = React.useState(
    () => util.strNull(window.localStorage.userName) || '비회원',
  );

  useEffect(() => {

    setOwnerFamID(localStorage.getItem('ownerFamID') || '');
    const userCusID = localStorage.getItem('userCusID') || '';
    api.post('customer/api/v1/CU_005_001', { cusId: userCusID }).then(res => {
      if (res.data.length > 0) {
        for (let tp of res.data) {
          if (tp.famId === localStorage.getItem('ownerFamID') || '') {  // 본인 검진 결과만 조회
            api.post('customer/api/v1/CU_005_002', { famId: tp.famId }).then(res => {
              let resultTemp = res.data.map((v: any) => true ? { ...v, famName: tp.famName, famId: tp.famId } : v);
              setResultData((prev) => prev.concat(resultTemp).sort(compare).reverse());
            }).catch(function (error) {
              console.log(error)
            });
          }
        }
      }
    }).catch(function (error) {
      console.log(error)
    });

    api.get('permission/getProfile').then((res: any) => {
      // 빈 값으로 덮어쓰면 저장된 이름까지 지워진다 — 값이 있을 때만 갱신한다
      const name = util.strNull(res?.data?.name);
      if (name !== '') setMemberName(name);
    }).catch(function (error: any) {
      console.log(error)
    });

  }, []);

  function compare(a: any, b: any) {
    if (a.year < b.year) {
      return -1;
    }
    if (a.year > b.year) {
      return 1;
    }
    return 0;
  }



  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 7, pb: 12, pl: 2, pr: 2, minWidth: 320 }}>
      <Top title='건강 검진 결과' />


      <Card sx={{ borderRadius: 3, mt: 4, p: 2, }}>
        {/* <Stack direction={'row'} >
            <Typography sx={{ fontSize: 16, fontWeight: 700 }}>검진결과 내역</Typography>
            <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#555', ml: 'auto' }} />
          </Stack>
          <Divider sx={{ mt: 1, mb: 1.5 }} /> */}

        <Stack direction={'column'} justifyContent={'space-evenly'} alignItems={'center'}>
          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>{memberName}<Typography component={'span'} sx={{ fontSize: 14 }}> 님의 검진 결과 </Typography></Typography>
          <Typography sx={{ mt: 1, fontSize: 16, fontWeight: 700 }}>{resultData.filter((v: any) => v.famId === ownerFamID).length}<Typography component={'span'} sx={{ fontSize: 14 }}> 건</Typography></Typography>

          <Card sx={{ mt: 2, border: '1px solid #f18322', py: .5, px: 2, borderRadius: 5, }}>
            <HealthResultCompare
              componentName={'최근 3년 결과 비교'}
              anchor="bottom" />
          </Card>
        </Stack>
      </Card>

      <Stack direction={'row'} pr={1}>

      </Stack>



      {resultData.length <= 0 ? (
        <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
          <ContentPasteOffIcon sx={{ fontSize: 50, color: '#bbb' }} />
          <Typography sx={{ fontSize: 16, color: '#888' }} >검진결과 정보가 없습니다.</Typography>
          <Box sx={BtnStyle}>
            <Button variant="contained" sx={BottomBtnStyle} onClick={() => { navigate('../reservation') }}>
              건강검진 예약하기
            </Button>
          </Box>
        </Stack>
      ) : (
        resultData && resultData.map((result: any, index: any) => (
          <Card sx={{ borderRadius: 3, mt: 4, }}>
            {/* <BeenhereIcon sx={{ fontSize: 40, position: 'absolute', color: '#007e05de' }} /> 확정시  */}

            <Stack direction="row" justifyContent={'center'} alignItems="center" spacing={2} sx={{ p: 2, }}>
              <Typography sx={{ fontWeight: 700, }} >{result.year}</Typography>
              <Typography sx={{ fontSize: 14, }}>{result.hospitalName}</Typography>
            </Stack>



            <Stack direction="row" justifyContent={'center'} spacing={2} sx={{ pb: 2 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 700, }}>{result.famName}<Typography component={'span'} sx={{ fontSize: 14, }}>({result.famId === ownerFamID ? '본인' : '가족'})</Typography></Typography>

              <Chip label={result.service} size="small" variant="outlined" sx={{ verticalAlign: 'top', color: '#f18322', width: 70 }}></Chip>
              {/* <Chip label='확정' size="small" sx={{ verticalAlign: 'top', bgcolor:'#f18322', color:'#fff'  }}></Chip> */}
            </Stack>

            {/* <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0 }}>
              <Typography sx={{ fontSize: 14, mb: 0.5 }}>
                30만원 종합형
              </Typography>
              <Typography sx={{ fontSize: 12, }}>
                위내시경, 뇌CT(128채널 이상), 갑상선 초음파
              </Typography>
            </Stack> */}

            {/*
            <Stack direction="row" justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#f5f5f5', p: 1 }}>
              <SentimentSatisfiedAltIcon sx={{ fontSize: 30, bgcolor: '#fff', borderRadius: '50%', color: '#48bf00' }} />
              <Typography sx={{ fontSize: 16, fontWeight: 700, ml: 1, color: '#48bf00' }}>정상A</Typography>
            </Stack>
    
            <Stack direction="row" justifyContent={'center'} alignItems={'center'}  sx={{ bgcolor: '#f5f5f5', p:1 }}>
              <SentimentNeutralIcon sx={{fontSize:30, bgcolor:'#fff', borderRadius:'50%', color:'#f5ac00'}} />
              <Typography sx={{ fontSize: 16, fontWeight: 700, ml:1, color:'#f5ac00'}}>정상B(경계)</Typography>
            </Stack>
    
            <Stack direction="row" justifyContent={'center'} alignItems={'center'}  sx={{ bgcolor: '#f5f5f5', p:1 }}>
              <SickIcon sx={{fontSize:30, bgcolor:'#fff', borderRadius:'50%', color:'#f37200'}} />
              <Typography sx={{ fontSize: 16, fontWeight: 700, ml:1, color:'#f37200'}}>일반질환의심</Typography>
            </Stack>
    */}

            <Stack direction={'column'} sx={{ p: 2 }}>
              <Stack direction={'row'} justifyContent={'space-evenly'} spacing={2} mb={2}>
                <HealthResultItem
                  componentName="기본검사"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '기본검사')}
                  src={icon_inspection1} width="60%" height="auto" />

                <HealthResultItem
                  componentName="신장검사"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '신장검사')}
                  src={icon_inspection2} width="60%" height="auto" />

                <HealthResultItem
                  componentName="일반혈액"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '일반혈액검사')}
                  src={icon_inspection3} width="60%" height="auto" />

                <HealthResultItem
                  componentName="심혈관계"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '심혈관계검사')}
                  src={icon_inspection4} width="60%" height="auto" />
              </Stack>

              <Stack direction={'row'} justifyContent={'space-evenly'} spacing={2} mb={2}>
                <HealthResultItem
                  componentName="<span style='letter-spacing:0'>간기능</span><br />간염"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '간기능/간염검사')}
                  src={icon_inspection5} width="60%" height="auto" />

                <HealthResultItem
                  componentName="당뇨<br />췌장<br />빈혈"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '당뇨/췌장/빈혈검사')}
                  src={icon_inspection6} width="60%" height="auto" />

                <HealthResultItem
                  componentName="<span style='letter-spacing:0'>갑상선</span><br />류마티스<br />통풍"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '갑상선/류마티스/통풍검사')}
                  src={icon_inspection7} width="60%" height="auto" />

                <HealthResultItem
                  componentName="종양검사"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '종양검사')}
                  src={icon_inspection8} width="60%" height="auto" />
              </Stack>

              <Stack direction={'row'} justifyContent={'space-evenly'} spacing={2} mb={2}>
                <HealthResultItem
                  componentName="비뇨<br /><span style='letter-spacing:0'>생식계</span>"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '비뇨생식계 및 성별 질환')}
                  src={icon_inspection9} width="60%" height="auto" />

                <HealthResultItem
                  componentName="장비검사"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '장비검사')}
                  src={icon_inspection10} width="60%" height="auto" />

                <HealthResultItem
                  componentName="기타검사"
                  anchor="bottom" resultItemData={result.resultItemList.filter((v: any) => v.categoryA === '기타검사')}
                  src={icon_inspection11} width="60%" height="auto" />

                <HealthResultItem
                  componentName="종합소견"
                  anchor="bottom" resultItemData={util.strNull(result.totalResult) !== '' ? result.totalResult.split('\r\n\r\n') : []}
                  src={icon_inspection12} width="60%" height="auto" />
              </Stack>
            </Stack>

            <HealthResultTotal
              componentName="전체 검진결과 보기"
              anchor="bottom" resultItemData={result.resultItemList}
              totalResult={util.strNull(result.totalResult) !== '' ? result.totalResult.split('\r\n\r\n') : []}
              src="" width="" />

          </Card>
        ))
      )}


      <Bottom />
    </Container >
  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 8,
  boxSizing: 'border-box',
  width: '80%',
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default HealthResult;